const Error = () => <h1> You've got an error!</h1>;
export default Error;
